<p-toast></p-toast>
<div class="w-full flex flex-column gap-3">
  <b class="block w-full text-left font-medium text-xl" style="color: #052647;">Personal Details</b>
  <b class="block w-full text-left font-small text-l" style="color: #052647;">Email: {{email}}</b>
  <form [formGroup]="basicInfoForm" (ngSubmit)="onSubmit()" class="w-full flex flex-column gap-3">
    <ul class="w-full grid">
      <li class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">First Name</b>
        <input pInputText formControlName="firstName" class="w-full" />
        <small *ngIf="submitted && basicInfoForm.controls['firstName'].invalid" class="text-red-500">First name is required</small>
      </li>
      <li class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Last Name</b>
        <input pInputText formControlName="lastName" class="w-full" />
        <small *ngIf="submitted && basicInfoForm.controls['lastName'].invalid" class="text-red-500">Last name is required</small>
      </li>
      <li class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Gender</b>
        <p-dropdown [showClear]="true" [options]="genders" optionLabel="name" optionValue="value" formControlName="gender" class="w-full" styleClass="sel_full" />
        <small *ngIf="submitted && basicInfoForm.controls['gender'].invalid" class="text-red-500">Gender is required</small>
      </li>
      <li class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Date of Birth</b>
        <p-calendar formControlName="bornOn"
            [iconDisplay]="'input'"
            [showIcon]="true"
            inputId="icondisplay"
            class="w-full" styleClass="cal_full" />
        <small *ngIf="submitted && basicInfoForm.controls['bornOn'].invalid" class="text-red-500">Date of birth is required</small>
      </li>
      <li class="lg:col-6 col-12 flex flex-column gap-1">
        <b *ngIf="portal === 'student'" class="w-full block text-left font-normal text-base" style="color: #575B68;">Home Country</b>
        <b *ngIf="portal === 'mentor'" class="w-full block text-left font-normal text-base" style="color: #575B68;">Location</b>
        <p-dropdown 
          *ngIf="portal === 'student'"
          [showClear]="true" 
          [options]="countries" 
          optionLabel="name" 
          optionValue="countryCode" 
          formControlName="homeCountry" 
          class="w-full" 
          [filter]="true" 
          styleClass="sel_full" />

        <p-multiSelect 
          *ngIf="portal === 'mentor'"
          [showClear]="true" 
          [options]="countries" 
          optionLabel="name" 
          optionValue="countryCode" 
          formControlName="homeCountry" 
          class="w-full" 
          [filter]="true" 
          styleClass="sel_full" 
          display="chip"
          placeholder="Select countries"/>

        <small *ngIf="submitted && basicInfoForm.controls['homeCountry'].invalid" class="text-red-500">Country is required</small>
      </li>
      <li *ngIf="portal === 'student'" class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Destination</b>
        <p-multiSelect [showClear]="true"  [options]="countries" optionLabel="name" optionValue="countryCode" formControlName="destination" class="w-full" [filter]="true" styleClass="sel_full" />
        <small *ngIf="submitted && basicInfoForm.controls['destination'].invalid" class="text-red-500">destination is required</small>
      </li>
      <li  *ngIf="portal === 'student'" class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Degree Preference</b>
        <p-dropdown [showClear]="true" [options]="degreePrefs" optionLabel="name" optionValue="key" formControlName="degreePreference" class="w-full" styleClass="sel_full" />
        <small *ngIf="submitted && basicInfoForm.controls['degreePreference'].invalid" class="text-red-500">Degree Preference is required</small>
      </li>
      <li  *ngIf="portal === 'student'" class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">I plan on starting college in</b>
        <p-dropdown [options]="collageStartOnTimings" optionLabel="name" optionValue="key" formControlName="collageStartOn" [showClear]="true" [filter]="true" class="w-full" styleClass="sel_full" />
        <small *ngIf="submitted && basicInfoForm.controls['collageStartOn'].invalid" class="text-red-500">College Starting Preference is required</small>
      </li>
      <li *ngIf="portal === 'mentor'" class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Work Experience</b>
        <div class="w-full flex gap-1 align-items-start sm:flex-row flex-column" formGroupName="totalExperience">
          <div class="w-full flex flex-column gap-2 flex-1">
            <!-- <b class="text-left font-normal text-base">Years</b> -->
            <p-dropdown [options]="years" formControlName="years"
              [ngClass]="{'ng-invalid ng-dirty' : submitted && ! basicInfoForm.get('totalExperience.years')?.value}"
              optionLabel="name" placeholder="Year" styleClass="selectBox1" appendTo="body" class="w-full" />
          </div>
          <div class="w-full flex flex-column gap-2 flex-1">
            <!-- <b class="text-left font-normal text-base">Months</b> -->
            <p-dropdown [options]="months" formControlName="months"
              [ngClass]="{'ng-invalid ng-dirty' : submitted && ! basicInfoForm.get('totalExperience.months')?.value}"
              optionLabel="name" placeholder="Month" styleClass="selectBox1" appendTo="body" class="w-full" />
          </div>
        </div>
        <small *ngIf="submitted && basicInfoForm.controls['lastName'].invalid" class="text-red-500">Last name is required</small>
      </li>
      <li *ngIf="portal === 'mentor'" class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Organisation</b>
        <input pInputText formControlName="organisation" class="w-full" />
        <small *ngIf="submitted && basicInfoForm.controls['organisation'].invalid" class="text-red-500">Organisation is required</small>
      </li>

      <li *ngIf="portal === 'mentor'" class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Undergraduate College</b>
        <p-autoComplete [suggestions]="searchAutoCompleteInstitutes"  formControlName="undergraduateCollege"
          (completeMethod)="filterInstitutes($event)" optionLabel="name" placeholder="College Name"
          styleClass="fullWidth"
          class="w-full" />
        <small *ngIf="submitted && basicInfoForm.controls['undergraduateCollege'].invalid" class="text-red-500">Undergraduate College is required</small>
      </li>
      <li *ngIf="portal === 'mentor'" class="lg:col-6 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Graduate College</b>
        <p-autoComplete [suggestions]="searchAutoCompleteInstitutes"  formControlName="graduateCollege"
          (completeMethod)="filterInstitutes($event)" optionLabel="name" placeholder="College Name"
          styleClass="fullWidth"
          class="w-full" />
        <small *ngIf="submitted && basicInfoForm.controls['graduateCollege'].invalid" class="text-red-500">Graduate Collage is required</small>
      </li>
      
      <li  *ngIf="portal === 'mentor'" class="lg:col-12 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Profile Video Url</b>
        <input pInputText formControlName="profileVideoUrl" class="w-full" />
        <small *ngIf="submitted && basicInfoForm.controls['profileVideoUrl'].hasError('invalidYoutubeUrl')" class="text-red-500">Invalid YouTube URL</small>
      </li>
      
      <li *ngIf="portal === 'mentor'" class="lg:col-12 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Profile Text</b>
        <app-content-editor [htmlContent]="initialContent"
        (onContentChange)="onProfileTextContentChange($event)"></app-content-editor>
        <!-- <textarea pinputTextarea formControlName="whyToBeMentor" [rows]="4" style="box-shadow: none; border-color: #C0C0C0;" class="w-full"></textarea>  -->
        <small *ngIf="submitted && basicInfoForm.controls['whyToBeMentor'].invalid" class="text-red-500">Profile Text is required</small>
      </li>
      
      <li *ngIf="portal === 'mentor'" class="lg:col-12 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Top Admits</b>
        <p-autoComplete [suggestions]="searchAutoCompleteInstitutes" formControlName="topAdmits"
          (completeMethod)="filterInstitutes($event)" optionLabel="name" placeholder="Select top admits"
          [multiple]="true" styleClass="fullWidth" class="w-full" />
      </li>
      
      <li *ngIf="portal === 'mentor'" class="lg:col-12 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Services Specialization</b>
        <div class="w-full flex flex-column md:flex-row md:flex-wrap">
          <div *ngFor="let option of serviceOptions" class="md:col-6 col-12 flex align-items-center relative">
            <p-checkbox
              formControlName="servicesSpecialization"
              [value]="option.key"
              [label]="option.name"
              labelStyleClass="labelchk1"
              styleClass="chk1"
              class="w-full h-full relative"
            />
          </div>
          <div class="md:col-6 col-12 flex align-items-center relative">
            <p-checkbox value="Other - Please specify"
              label="Other - Please specify"  labelStyleClass="labelchk1" styleClass="chk1"
              class="w-full h-full relative" (onChange)="onOtherServiceChange($event)" />
          </div>
        </div>
        <div *ngIf="showOtherServiceInput" class="w-full flex flex-column gap-2 flex-1">
          <b class="text-left font-normal text-base">Please enter your specialization:</b>
          <div class="flex gap-2 w-full">
            <input class="input w-full" type="text" pInputText formControlName="otherServiceSpecControl" (keydown.enter)="addOtherService($event)" />
            <p-button label="Add" type="button" (onClick)="addOtherService()" [style]="{'background-color': '#000086', 'border-color': '#000086'}"></p-button>
          </div>
          <small class="ng-dirty ng-invalid text-red-500"
            *ngIf="basicInfoForm.get('otherServiceSpecControl')?.invalid && (submitted || basicInfoForm.get('otherServiceSpecControl')?.touched)">
            Other Specialization is required
          </small>
        </div>
        <small *ngIf="submitted && basicInfoForm.errors?.['servicesSpecializationRequired']" class="text-red-500">Services Specialization is required</small>
      </li>

      <li *ngIf="portal === 'mentor'" class="lg:col-12 col-12 flex flex-column gap-1">
        <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Subject Specialization</b>
        <div class="w-full flex flex-column md:flex-row md:flex-wrap">
          <div *ngFor="let option of subjectOptions" class="md:col-6 col-12 flex align-items-center relative">
            <p-checkbox
              formControlName="subjectSpecialization"
              [value]="option.key"
              [label]="option.name"
              labelStyleClass="labelchk1"
              styleClass="chk1"
              class="w-full h-full relative"
            />
          </div>
          <div class="md:col-6 col-12 flex align-items-center relative">
            <p-checkbox value="Other - Please specify"
              label="Other - Please specify"  labelStyleClass="labelchk1" styleClass="chk1"
              class="w-full h-full relative" (onChange)="onOtherSubjectChange($event)" />
          </div>
        </div>
        <div *ngIf="showOtherSubjectInput" class="w-full flex flex-column gap-2 flex-1">
          <b class="text-left font-normal text-base">Please enter your subject:</b>
          <div class="flex gap-2 w-full">
            <input class="input w-full" type="text" pInputText formControlName="otherSubjectSpecControl" (keydown.enter)="addOtherSubject($event)" />
            <p-button label="Add" type="button" (onClick)="addOtherSubject()" [style]="{'background-color': '#000086', 'border-color': '#000086'}"></p-button>
          </div>
          <small class="ng-dirty ng-invalid text-red-500"
            *ngIf="basicInfoForm.get('otherSubjectSpecControl')?.invalid && (submitted || basicInfoForm.get('otherSubjectSpecControl')?.touched)">
            Other Subject is required
          </small>
        </div>
        <small *ngIf="submitted && basicInfoForm.errors?.['subjectSpecializationRequired']" class="text-red-500">Subject Specialization is required</small>
      </li>
      <!-- <li class="lg:col-6 col-12 flex flex-column gap-1">
        <p-button label="Update Information" styleClass="btn_save" type="submit" [loading]="loading" />
      </li> -->
    </ul>
    <p-button label="Update Information" styleClass="btn_save" type="submit" [loading]="loading" />
  </form>
</div>
